export default __webpack_public_path__ + "static/juice1-b139e2b6e76141bebec5452e7a0f9f11.png";